<template>
  <Item border class="x-input">
    <slot name="label">
      <span class="text-[20px] text-[#3a3a3a]">{{ $props.label }}</span>
    </slot>
    <template #end>
      <div class="flex items-center relative">
        <input :type="$props.type" v-model="value" class="align-right text-[20px] w-full" @focus="handleFocus"
          @input="handleInput" :disabled="$props.disabled" />
        <el-icon size="20px" color="#A8A8A8" class="ml-[5px] absolute right-0" style="position: absolute"
          v-if="$props.clearable && value" @click="clearValue()">
          <IcCheckFalse />
        </el-icon>
      </div>
    </template>
  </Item>
</template>
<script lang="ts" setup>
import { ref, watch } from "vue";
import Item from "./Item.vue";
import { IcCheckFalse } from "@xpos/icons-svg";

const $emit = defineEmits(["input", "change", "update:modelValue"]);
const $props = defineProps({
  modelValue: {
    type: [String, Number],
  },
  label: {
    type: String,
  },
  clearable: {
    type: Boolean,
    default: true,
  },
  max: {
    type: Number,
  },
  min: {
    type: Number,
  },
  type: {
    type: String,
    default: "text",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
const value = ref($props.modelValue);
const handleFocus = (e: FocusEvent) => {
  const target = e.target as HTMLInputElement;
  const val = target!.value;
  setTimeout(() => {
    target!.setSelectionRange(0, val.length);
  }, 100);
};

const handleInput = (e: Event) => {
  const target = e?.target as HTMLInputElement;
  $emit("update:modelValue", target?.value);
  $emit("change", target.value);
  $emit("input", target.value);
};

const clearValue = () => {
  value.value = "";
  $emit("update:modelValue", "");
  $emit("change", "");
  $emit("input", "");
};

watch(
  () => $props.modelValue,
  (val) => {
    value.value = val;
  }
);
</script>
<style lang="sass" scoped>
.x-input
  height: 50px
  display: flex
  justify-content: space-between
  padding: 10px
  border-radius: var(--radius-8)
  transition: box-shadow 0.2s
  &:focus-within
    box-shadow: 0 0 0 2px var(--el-color-primary) inset
  input
    text-align: right!important
    outline: 0
    padding-right: 25px
    &:hover,
    &:focus
      border: none
      outline:0
</style>
